import React, {Component} from "react";
import "./AllCustomersHeader.css";
import {FormattedMessage} from "react-intl";

class AllCustomersHeader extends Component {
    render() {
        return (
            <thead>
            <tr>
                <th className="customer-username-resp">登録日</th>
                <th className="customer-name-resp"> 名前</th>
                <th className="customer-email-resp">メールアドレス</th>
                <th className="customer-actions-resp">
                    <FormattedMessage id="app.all-customers-header.actions"
                                      defaultMessage="Actions"
                                      description=""/>
                </th>

            </tr>
            </thead>
        )
    }
}

export default AllCustomersHeader;



// WEBPACK FOOTER //
// ./src/components/Admin/AllCustomers/AllCustomersHeader/AllCustomersHeader.js